angular.module('picmonicng').factory('ResetSpacedRepModal', [
  '$modal',
  function ($modal) {
    return {
      show: function () {
        $modal.open({
          templateUrl: '/templates/modals/reset-spaced-rep-modal.html',
          windowClass: 'pls-modal-abyss',
          controller: [
            '$scope',
            'User',
            'toaster',
            function ($scope, User, toaster) {
              $scope.loading = false;

              $scope.reset = function () {
                if ($scope.loading) {
                  return;
                }

                $scope.loading = true;

                User.deletev3(
                  { resource: 'spacedrep' },
                  function () {
                    toaster.success('Your Daily Quiz with Spaced Repetition stats have been reset.');
                    $scope.$close();
                  },
                  function () {
                    toaster.error('There was an error deleting your Daily Quiz with Spaced Repetition stats.');
                    $scope.loading = false;
                  }
                );
              };
            },
          ],
        });
      },
    };
  },
]);
